import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=4ea306e6&scoped=true&"
import script from "./Page1.vue?vue&type=script&lang=ts&"
export * from "./Page1.vue?vue&type=script&lang=ts&"
import style0 from "./Page1.vue?vue&type=style&index=0&id=4ea306e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea306e6",
  null
  
)

export default component.exports